import { createStore, type Store, type StoreActionApi } from 'react-sweet-state';

import type { PromptCardSource } from './PromptCardSource';
import type { State } from './State';

export const store: Store<
	State,
	{
		setPromptCardSource: (
			source: PromptCardSource | null,
		) => ({ setState }: StoreActionApi<State>) => void;
		takePromptCardSource: () => ({
			setState,
			getState,
		}: StoreActionApi<State>) => PromptCardSource | null;
	}
> = createStore({
	initialState: { source: null } as State,
	actions: {
		setPromptCardSource:
			(source: PromptCardSource | null): (({ setState }: StoreActionApi<State>) => void) =>
			({ setState }) => {
				setState({ source });
			},
		/**
		 * Returns the current prompt card source (if any) and clears it.
		 * Call this when the user sends a message to determine if they sent a prompt card as-is or tweaked it.
		 */
		takePromptCardSource:
			(): (({ setState, getState }: StoreActionApi<State>) => PromptCardSource | null) =>
			({ setState, getState }): PromptCardSource | null => {
				const source = getState().source;
				setState({ source: null });
				return source;
			},
	},
});
